export enum CheckoutStep {
  CONTACT_INFO = 1,
  SHIPPING_ADDRESS = 2,
  DELIVERY_OPTION = 3,
  PAYMENT = 4,
  REVIEW = 5,
}
